/**
 * Helper function file for endpoint data
 * 
 * Author: Sahil David <sahil.david@huumun.com>, Andrea Lopez <andrea.lopez@huumun.com>
 */

import { getLyraEndpoints } from '@/core/modules/lyra/services';

/**
 * Get relative tier for a given endpoint Id
 */
export function getEndpointTierId (endpointId: string): string {
    const sections = getLyraEndpoints('sections');

    const currentSection: any = sections.find((_: any) => _.endpointId === endpointId);
    return currentSection.endpoints || '';
}

/**
 * Get section for a given app section/flow
 */
export function getSectionTierId (endpointId: string): string {
    const sections = getLyraEndpoints('sections');

    const currentSection: any = sections.find((_: any) => _.endpointId === endpointId);
    return currentSection.sections || '';
}

/**
 * Get if product section
 */
export function isProductSection (endpointId: string): boolean {
    const sections = getLyraEndpoints('sections');

    const currentSection: any = sections.find((_: any) => _.endpointId === endpointId);
    return currentSection.product === 'true';
}
